import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SharedService {
	private menuItemClickSource = new Subject<any>();
	menuItemClick$ = this.menuItemClickSource.asObservable();

	triggerMenuItemClick(item: any) {
		this.menuItemClickSource.next(item);
	}
}
